// client/src/pages/pmPortal/PmPortalLoginPage.js
// One login for both audiences. The role comes back from the server with the token —
// the person signing in never declares which they are, so a tenant cannot arrive at
// the owner side by picking the wrong option on a form.
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePmPortalAuth } from '../../hooks/usePmPortalAuth';

const PmPortalLoginPage = () => {
    const { login, error, loading } = usePmPortalAuth();
    const [loginEmail, setLoginEmail] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        const result = await login(loginEmail, password);
        if (!result) return;
        if (result.mustChangePassword) return navigate('/pm-portal/change-password');
        navigate(result.role === 'owner' ? '/pm-portal/owner' : '/pm-portal/tenant');
    };

    return (
        <div className="min-h-screen bg-slate-100 flex items-center justify-center p-4">
            <div className="max-w-md w-full bg-white p-8 rounded-lg shadow">
                <h1 className="text-2xl font-bold text-slate-800 mb-1 text-center">Property Portal</h1>
                <p className="text-sm text-slate-500 mb-6 text-center">For owners and residents</p>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <input
                        type="email"
                        value={loginEmail}
                        onChange={(e) => setLoginEmail(e.target.value)}
                        placeholder="Email"
                        required
                        autoComplete="username"
                        className="w-full p-3 border rounded-md"
                    />
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Password"
                        required
                        autoComplete="current-password"
                        className="w-full p-3 border rounded-md"
                    />
                    {error && <p className="text-red-600 text-sm">{error}</p>}
                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full px-4 py-3 text-white bg-slate-800 rounded-md hover:bg-slate-900 disabled:bg-indigo-400"
                    >
                        {loading ? 'Signing in…' : 'Sign In'}
                    </button>
                </form>
                <p className="mt-6 text-xs text-slate-500 text-center">
                    Access is issued by the office. If you have not been given a password, or yours
                    has stopped working, contact the managing broker.
                </p>
            </div>
        </div>
    );
};

export default PmPortalLoginPage;
